import { appConfig } from "@app/config/appConfig";

export const ENCRYPTION_KEY = appConfig.encryption.key;

export const IS_ENCRYPTION_ENABLED = appConfig.encryption.enabled;
